import { memo } from 'react';

function CalendarIcon() {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none">
			<path
				fill="#787878"
				fillRule="evenodd"
				d="M4.003 2.672h8a2.667 2.667 0 0 1 2.666 2.667v6.666a2.667 2.667 0 0 1-2.666 2.667h-8a2.667 2.667 0 0 1-2.667-2.667V5.34a2.667 2.667 0 0 1 2.667-2.667Zm0 1.333A1.333 1.333 0 0 0 2.669 5.34v6.666a1.333 1.333 0 0 0 1.334 1.333h8a1.333 1.333 0 0 0 1.333-1.333V5.34a1.333 1.333 0 0 0-1.333-1.334h-8Z"
				clipRule="evenodd"
			/>
			<path
				fill="#787878"
				fillRule="evenodd"
				d="M2 6.67a.667.667 0 0 1 .667-.667h10.666a.667.667 0 1 1 0 1.333H2.667A.667.667 0 0 1 2 6.669Zm3.333-5.334A.667.667 0 0 1 6 2.003v2.666a.667.667 0 0 1-1.333 0V2.003a.667.667 0 0 1 .666-.667Zm5.334 0a.667.667 0 0 1 .666.667v2.666a.667.667 0 1 1-1.333 0V2.003a.666.666 0 0 1 .667-.667Z"
				clipRule="evenodd"
			/>
			<path
				fill="#787878"
				d="M5.333 8.667a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0Zm0 2.666a.667.667 0 1 1-1.333 0 .667.667 0 0 1 1.333 0Zm3.334-2.666a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0Zm0 2.666a.667.667 0 1 1-1.334 0 .667.667 0 0 1 1.334 0ZM12 8.667a.666.666 0 1 1-1.333 0 .666.666 0 0 1 1.333 0Zm0 2.666a.666.666 0 1 1-1.333 0 .666.666 0 0 1 1.333 0Z"
			/>
		</svg>
	);
}

export default memo(CalendarIcon);
